__webpack_require__.p = "https://apps.his.nhatquang.tech/";